/**
 * =====================================
 * File: PageCard.js
 * Component: PageCard, PageTitle
 * Purpose: Create a title and body containers for page
 *  content
 * Author: Noah Fultz
 * Date: 2026-06-16
 * =====================================
 */

import './PageElements.css';


function PageTitle({ id = null, children }) {
	return (
		<header className='pagetitle-container' id={id}>
			<h1 className='pagetitle-text'>{ children }</h1>
		</header>
	);
}


function PageCard({ header = null, id = null, children }) {
	return (
		<div className='pagecard-container' id={id}>

			{header && (
				<div className='pagecard-headbar'>
					<h2 className='pagecard-headtext'>{ header.replace('_', ' ') }</h2>
				</div>
			)}

			{children}
		</div>
	)
}


export {
	PageTitle,
	PageCard
};